
import { i18nText } from '@/locales';
//TODO:: нужно будет удалить либо переместить в зависимости  от Api

export class Workers {
    id: number | null;
    name: string | undefined;
    category: string;
    constructor() {
        this.id = null;
        this.name = "";
        this.category = "";
    }
}
export interface Schema {
    json?: null;
}
export class ServiceFormDataWorkers {
    workers: Array<Workers>;
    constructor() {
        this.workers = [];
    }
    add(item: Workers): void {
        this.workers.push(item);
    }
}
export class BaseServiceForm {
    id: number | null;
    price_first: number;
    price_second: number;
    service_duration: string;
    constructor() {
        this.id = null;
        this.price_first = 0;
        this.price_second = 0;
        this.service_duration = "";
    }
}
export class ServiceFormData extends BaseServiceForm {
    active:                     boolean;
    name:                       string;
    description:                string | null;
    online_appointment_name:    string | null;
    category_id:                number | null;
    nomenclature_id:            number | null;
    salon_id:                   number | null;
    image:                      number | null;
    online_appointment:         boolean;
    side:                       string | null;

    constructor() {
        super();
        this.active = false;
        this.name = "";
        this.description = null;
        this.online_appointment_name = null;
        this.category_id = null;
        this.nomenclature_id = null;
        this.salon_id = null;
        this.image = null;
        this.online_appointment = false;
        this.side = null;
    }
}
export const FormRules = {
    name: [
        { required: true, message: i18nText("Пожалуйста укажите наименование"), trigger: "change" },
        { min: 2, message: "Length should be 3 to 5", trigger: "blur" },
    ],
    service_duration: [{ required: true, message: i18nText("Пожалуйста укажите длительность"), trigger: "change" }],
    //online_appointment_name: [{ required: true, message: "Пожалуйста укажите наименование услуги", trigger: "change" }],
    //description: [{ required: true, message: "Пожалуйста укажите описание", trigger: "change" }],
    salon_id: [{ required: true, message: i18nText("Пожалуйста укажите студию"), trigger: "change" }],
};
